import { ArticleType } from '../../article-types/article-type.model';
import { ArticleTypeService } from '../../article-types/article-type.service';
import { BasicArticle } from './../basicarticle.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-basicarticle-articletype',
    templateUrl: './basicarticle-articletype.component.html',
    styleUrls: ['./basicarticle-articletype.component.scss'],
    standalone: false
})
export class BasicarticleArticletypeComponent implements OnInit {

  private _basicArticle: BasicArticle;

  articleType: ArticleType;

  @Input() set basicArticle(basicArticle: BasicArticle) {
    this._basicArticle = basicArticle;
    this.articleType = this.articleTypeService.getById(this.basicArticle.articleTypeId).completeArticleType;
  }

  get basicArticle() {
    return this._basicArticle;
  }

  constructor(private articleTypeService: ArticleTypeService) { }

  ngOnInit(): void {
  }

}
